import React, { useEffect, useState } from "react";
import "./Hero.css";

import img1 from "../Assets/hero/2.jpg";
import img2 from "../Assets/hero/6.jpg";
import img3 from "../Assets/hero/8.jpg";
import img4 from "../Assets/hero/9.jpg";
import img6 from "../Assets/hero/hr6.JPG";

import m1 from "../Assets/hero/HERO1.jpg";
import m2 from "../Assets/hero/HERO2.jpg";
import m3 from "../Assets/hero/HERO3.jpg";

import siegar from "../Assets/logo/Sieger.svg";
import agkc from "../Assets/logo/agkc1.png";

const desktopImages = [img1, img2, img3, img4, img6];

const mobileImages = [m1, m2, m3];

export default function Hero() {
  const [currentImage, setCurrentImage] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const images = isMobile ? mobileImages : desktopImages;

    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isMobile]);

  const images = isMobile ? mobileImages : desktopImages;

  return (
    <section
      className="hero"
      id="Hero"
      style={{ backgroundImage: `url(${images[currentImage]})` }}
    >
      <div className="hero-overlay">
        <div className="hero-inner container">
          <h1 className="hero-top">AITAM's GoKarting</h1>
          <h2 className="hero-large">Championship Season 3</h2>
          <h2 className="hero-large special">Special Edition</h2>
          <p className="subtitle">
            4<sup>th</sup> to 7<sup>th</sup> March 2026{" "}
          </p>

          <div className="sponsors">
            <div className="sponsor-item">
              <img className="img1" src={agkc} alt="Sponsor 1" />
            </div>

            <div className="sponsor-item powered">
              <span>POWERED BY</span>
              <img className="siger" src={siegar} alt="Sponsor 2" />
            </div>
          </div>

          <div className="cta-row">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLScZnKBW10oTRiaRK-kyb5OuCh94Zm4mnwII7zRU_lGMmDqQYA/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="btn solid"
            >
              Click Here For Registration
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
